<template>
  <div class="creationcomplete">
    <div class="header">
      <enterprise-header></enterprise-header>
    </div>
    <div class="content">
      <div class="main">
        <div style="width:1280px;height:828px;background:#ffffffcf;margin:17px auto;margin-bottom:0;border-radius: 4px">
          <div class="validationsuccee">
            <div style="margin:0 auto;padding-top:105px;height:32px;">
              <steps ref="stepsChild" :width="width"></steps>
            </div>
            <div v-if="status == 0" style="text-align: center;margin-top:65px">
              <img :src="yanzheng" alt="" />
            </div>
            <div v-if="status == 2" style="text-align: center;margin-top:65px">
              <img :src="qiyeshibai" alt="" />
            </div>
            <div v-if="status == 0" style="margin-top:38px;text-align: center;">
              <div style="margin:0 auto;font-size:22px;color:var(--key-color)">
                企业【{{ enterpriseName }}】创建完成，待审核通过后即可管理该企业
              </div>
            </div>
            <div v-if="status == 2" style="margin-top:54px;text-align: center;">
              <div style="margin:0 auto;font-size:22px;color:var(--key-color)">
                很抱歉，你创建的企业【{{ enterpriseName }}】审核未通过
              </div>
              <div style="margin:0 auto;font-size:14px;color:var(--info-color)9;width: 1140px;margin-top:25px">
                驳回原因：{{ remark }}
              </div>
            </div>
            <div v-if="status == 0" style="margin:0 auto;text-align: center;margin-top:29px;">
              <el-button :loading="loadingling" type="primary" size="small" @click="querydetails">刷新审核结果</el-button>
            </div>
            <div v-if="status == 2" style="margin:0 auto;text-align: center;margin-top:36px;">
              <el-button :loading="loadingling2" type="primary" size="small" plain @click="del">删除企业</el-button>
              <el-button :loading="loadingling2" type="primary" size="small" @click="gofillinformation">重新申请</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import steps from "@/CommonDP/components/steps";
import registerService from "@/CommonDP/service/register-service";
import EnterpriseHeader from "./components/userEnterHeader";
import { storage } from "@/CommonDP/utils";
export default {
  components: {
    steps,
    EnterpriseHeader
  },
  data() {
    return {
      yanzheng: require("@/CommonDP/assets/enterprise/支付成功 (1).png"),
      qiyeshibai: require("@/CommonDP/assets/enterprise/qiyeshibai.png"),
      name: "北京致一科技有限公司",
      stepsIndex: 2,
      stepsData: [{ name: "同意协议" }, { name: "填写资料" }, { name: "创建完成" }],
      enterpriseName: "",
      status: 0,
      remark: "",
      loadingling: false,
      loadingling2: false,
      width: "319"
    };
  },
  created() {
    console.log(this.$route.query.id);
    this.querydetails();
  },
  methods: {
    querydetails() {
      this.loadingling = true;
      registerService
        .enterprisegetEnterpriseDetails(this.$route.query.id)
        .then((res) => {
          if (res.result === "0") {
            console.log(res.data);
            this.enterpriseName = res.data.enterpriseName;
            this.status = res.data.status;
            this.remark = res.data.remark;
            this.loadingling = false;
            // 审核通过可以直接进去企业
            if (this.status === 1) {
              this.$store.dispatch("setUnauthorized", 1);
              this.$store.dispatch("setEnterpriseId", res.data.enterpriseId);
              this.$store.dispatch("setIsTrial", res.data.isTrial);
              this.$router.push({ name: "mainMg" });
            }
          }
        })
        .catch(() => {});
    },
    gofillinformation() {
      var params = {
        enterpriseName: "",
        creditCode: "",
        userName: "",
        idCard: "",
        verifyCode: "",
        fileList1: [],
        fileList2: []
      };
      storage.set("setenterpriseForm", JSON.stringify(params));
      this.$router.replace({
        path: "/fillinformation",
        query: { fftype: "1", id: this.$route.query.id }
      });
    },
    del() {
      // 删除完企业以后 如果没有企业 就跳到无企业的页面 有企业 就跳到个人中心企业信息页
      this.$confirm("删除企业后，您将无法在看到该条企业数据，是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadingling2 = true;
          registerService
            .updateEnterpriseDissolve(this.$route.query.id)
            .then((res) => {
              if (res.result === "0") {
                this.loadingling2 = false;
                this.$message({
                  duration: 1000,
                  message: "删除成功",
                  type: "success",
                  showClose: true
                });
                registerService.usergetEnterpriseList().then((res) => {
                  if (res.result === "0") {
                    console.log(res.data.length);
                    if (res.data.length) {
                      // 删除企业以后如果还有企业就跳到个人中心企业信息页 没有企业就跳到创建企业或者使用企业页
                      this.$router.push({ name: "userCneter" });
                    } else {
                      this.$router.replace({ path: "/enterprisepage", query: { pagetype: "0" }});
                    }
                  }
                });
              }
            })
            .catch(() => {
              this.loadingling2 = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.creationcomplete {
  min-width: 1270px;
  width: 100%;
  min-height: 937px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    line-height: 68px;
    overflow: hidden;
    position: absolute;
    top: 0;
    text-align: center;
    box-sizing: border-box;
  }
  .content {
    position: absolute !important;
    position: relative;
    top: 68px !important;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    min-height: 1000px;
    overflow-y: auto;
    // text-align: center;
    background: url("../../assets/enterprise/qiye.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
  }
}
</style>
